import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const PediatricsIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M80.2144 40C80.2144 61.8153 62.5296 79.5 40.7144 79.5C18.8991 79.5 1.21436 61.8153 1.21436 40C1.21436 18.1848 18.8991 0.5 40.7144 0.5C62.5296 0.5 80.2144 18.1848 80.2144 40Z'
    />
    <g clipPath='url(#clip0_414_7128)'>
      <path
        d='M44.0646 43.9456C43.1178 43.3451 42.5116 42.2906 42.5116 41.1218V39.2827H33.3973V41.1218C33.3973 42.2906 32.7911 43.3451 31.8442 43.9456L37.9113 55.2776L44.0646 43.9456Z'
        fill='#F89580'
      />
      <path
        d='M55.967 60.8334L55.1387 52.4459C54.8023 49.0406 52.366 46.2123 49.0481 45.3753L45.044 44.3653C44.6897 44.2768 44.3605 44.1334 44.0647 43.9458L37.9545 52.5001C33.1359 45.7541 33.1359 45.7541 31.8442 43.9458C31.5483 44.1334 31.2192 44.2768 30.8649 44.3653L26.7901 45.384C23.4643 46.2154 21.0198 49.0473 20.6829 52.4588L19.8708 60.6813C19.8628 60.7627 19.9268 60.8334 20.0086 60.8334H26.8433V65.0001H49.0644V60.8334H55.967Z'
        fill='#01C0FA'
      />
      <path
        d='M40.7417 62.9548C40.3371 62.9548 40.0093 62.6269 40.0093 62.2224V60.8335C40.0093 60.429 40.3371 60.1011 40.7417 60.1011H46.2973C46.7019 60.1011 47.0297 60.429 47.0297 60.8335C47.0297 61.238 46.7019 61.5659 46.2973 61.5659H41.4741V62.2224C41.4741 62.6269 41.1463 62.9548 40.7417 62.9548Z'
        fill='#08A9F1'
      />
      <path
        d='M30.3292 46.6036C30.0001 46.8388 29.9238 47.2962 30.159 47.6253L35.6517 55.3152C35.7891 55.5077 36.0112 55.622 36.2477 55.622H39.6602C39.8968 55.622 40.1187 55.5077 40.2562 55.3152L45.7491 47.6253C45.9843 47.2961 45.908 46.8387 45.5789 46.6036C45.2497 46.3684 44.7922 46.4447 44.5572 46.7739L39.2834 54.1571H36.7722L37.9545 52.5C37.634 52.0513 37.3348 51.6324 37.0552 51.2409L35.7984 53.0004L31.351 46.7738C31.1158 46.4448 30.6584 46.3683 30.3292 46.6036Z'
        fill='#08A9F1'
      />
      <path
        d='M30.8059 27.8281H28.445C27.38 27.8281 26.5166 28.6915 26.5166 29.7565C26.5166 31.8493 28.2131 33.5458 30.3059 33.5458H30.3787L30.8059 27.8281Z'
        fill='#FFB09E'
      />
      <path
        d='M45.103 27.8281H47.4639C48.5289 27.8281 49.3923 28.6915 49.3923 29.7565C49.3923 31.8493 47.6958 33.5458 45.603 33.5458H45.5302L45.103 27.8281Z'
        fill='#F89580'
      />
      <path
        d='M48.2087 44.0061H46.7949C45.8352 44.0061 45.0571 44.7841 45.0571 45.7439C45.0571 47.6298 46.5859 49.1586 48.4719 49.1586H48.5375L48.2087 44.0061Z'
        fill='#FFE5C2'
      />
      <path
        d='M62.0511 44.0061H60.6373L60.3086 49.1586H60.3742C62.2602 49.1586 63.789 47.6298 63.789 45.7439C63.7889 44.7841 63.0108 44.0061 62.0511 44.0061Z'
        fill='#FED2A4'
      />
      <path
        d='M37.9542 40.6945C33.7011 40.6945 30.1796 37.3905 29.9088 33.146L29.4201 25.485C29.1057 20.5579 33.0171 16.3889 37.9542 16.3889C42.8913 16.3889 46.8028 20.5579 46.4884 25.485L45.9996 33.146C45.7288 37.3905 42.2074 40.6945 37.9542 40.6945Z'
        fill='#FFCEBF'
      />
      <path
        d='M39.9492 29.9414H35.9595C35.555 29.9414 35.2271 29.6136 35.2271 29.209C35.2271 28.8044 35.555 28.4766 35.9595 28.4766H39.9492C40.3537 28.4766 40.6816 28.8044 40.6816 29.209C40.6816 29.6136 40.3537 29.9414 39.9492 29.9414Z'
        fill='#0681AF'
      />
      <path
        d='M37.9542 16.3889C35.0899 16.3889 32.571 17.792 31.022 19.9323H34.3602C34.9213 19.9323 35.4342 20.2493 35.6852 20.7511L35.8041 20.989C36.3349 22.0505 37.423 22.6906 38.6098 22.7102C39.1169 22.7186 39.5705 23.0304 39.7594 23.5026L41.4191 27.652C41.861 28.7568 42.0511 29.9463 41.9753 31.1338C41.7045 35.3783 38.183 38.6823 33.9299 38.6823C33.4359 38.6823 32.9518 38.6376 32.4815 38.5522C33.9228 39.8847 35.8488 40.6944 37.9542 40.6944C42.2073 40.6944 45.7288 37.3904 45.9996 33.1459L46.4884 25.4849C46.8028 20.558 42.8913 16.3889 37.9542 16.3889Z'
        fill='#FFB09E'
      />
      <path
        d='M47.6798 62.9878H26.8125V64.9999H49.0337V62.6567C48.6287 62.8682 48.1683 62.9878 47.6798 62.9878Z'
        fill='#08A9F1'
      />
      <path
        d='M32.3701 65.0001H18.5644C18.5151 65.0001 18.4719 64.9675 18.4584 64.9202L15.7436 55.4184C15.7235 55.3479 15.7763 55.2778 15.8495 55.2778H29.5923L32.3701 65.0001Z'
        fill='#FD6930'
      />
      <path
        d='M29.5923 55.2778H26.1429L27.316 59.3837C27.832 61.1899 26.4759 62.9879 24.5974 62.9879H17.9062L18.4583 64.9201C18.4718 64.9674 18.515 65 18.5643 65H32.37L29.5923 55.2778Z'
        fill='#FD5426'
      />
      <path
        d='M24.6319 53.8889H19.2226C19.1493 53.8889 19.0965 53.959 19.1166 54.0294L19.8473 56.5869C19.8608 56.6341 19.904 56.6667 19.9532 56.6667H25.4257L24.6319 53.8889Z'
        fill='#B4D2E2'
      />
      <path
        d='M54.4236 58.5184C56.5567 58.5184 58.409 56.3903 59.3399 54.6265L59.056 54.5454C58.3146 54.3335 57.8035 53.656 57.8035 52.885V50.8879C56.8399 51.5492 55.6746 51.9344 54.4239 51.9344C53.1732 51.9344 52.0079 51.5492 51.0443 50.8879V52.885C51.0443 53.656 50.5332 54.3335 49.7919 54.5454L49.5073 54.6267C50.4384 56.3905 52.2906 58.5184 54.4236 58.5184Z'
        fill='#FED2A4'
      />
      <path
        d='M60.9617 55.0901L59.3399 54.6267C58.409 56.3905 56.5566 57.5926 54.4236 57.5926C52.2906 57.5926 50.4384 56.3906 49.5074 54.6269L47.8864 55.09C45.0881 55.8895 43.1587 58.4472 43.1587 61.3577V65H65.6142C65.6557 65 65.6893 64.9665 65.6893 64.9249V61.3575C65.6892 58.4472 63.76 55.8896 60.9617 55.0901Z'
        fill='#FED402'
      />
      <path
        d='M60.9618 55.0901L59.34 54.6267C59.2575 54.7831 59.1678 54.9349 59.0713 55.0819C60.0701 56.2374 60.659 57.7375 60.659 59.3453V60.672C60.659 61.951 59.6222 62.9879 58.3431 62.9879H43.1587V65H65.6142C65.6557 65 65.6893 64.9665 65.6893 64.9249V61.3575C65.6893 58.4472 63.7601 55.8896 60.9618 55.0901Z'
        fill='#FAC600'
      />
      <path
        d='M61.4304 44.4891L61.5975 42.1493C61.8951 37.9858 58.5976 34.4443 54.4236 34.4443C50.2497 34.4443 46.9523 37.9855 47.2496 42.1489L47.4261 44.6199L61.4304 44.4891Z'
        fill='#855151'
      />
      <path
        d='M59.2625 42.1614L57.3647 38.366L57.326 38.4176C55.436 40.9375 52.8226 42.8212 49.8344 43.8172L47.4263 44.62L47.5282 46.0476C47.7866 49.6653 50.7968 52.4682 54.4236 52.4682C58.0504 52.4682 61.0605 49.6655 61.319 46.048L61.4305 44.4892C60.5064 43.9418 59.7503 43.137 59.2625 42.1614Z'
        fill='#FFF3DE'
      />
      <path
        d='M59.2624 42.1614L57.3646 38.366L57.3259 38.4176C56.7579 39.175 56.1246 39.8748 55.4353 40.5103C55.703 40.9603 56.0304 41.3678 56.4062 41.7232C57.036 42.3187 57.3564 43.1713 57.2946 44.0359C57.036 47.6534 54.0259 50.4561 50.3992 50.4561C50.0908 50.4561 49.7869 50.4358 49.4888 50.3965C50.7471 51.6786 52.4984 52.4683 54.4235 52.4683C58.0503 52.4683 61.0604 49.6656 61.3189 46.0481L61.4304 44.4893C60.5063 43.9418 59.7502 43.137 59.2624 42.1614Z'
        fill='#FFE5C2'
      />
      <path
        d='M36.012 31.6666H31.5631C31.2575 31.6666 31.0098 31.4188 31.0098 31.1133V28.0533C31.0098 27.7478 31.2575 27.5 31.5631 27.5H36.012C36.3176 27.5 36.5653 27.7478 36.5653 28.0533V31.1132C36.5653 31.4188 36.3176 31.6666 36.012 31.6666Z'
        fill='#C8EFFE'
      />
      <path
        d='M39.8966 31.6666H44.3455C44.6511 31.6666 44.8988 31.4188 44.8988 31.1133V28.0533C44.8988 27.7478 44.6511 27.5 44.3455 27.5H39.8966C39.591 27.5 39.3433 27.7478 39.3433 28.0533V31.1132C39.3433 31.4188 39.591 31.6666 39.8966 31.6666Z'
        fill='#C8EFFE'
      />
      <path
        d='M44.3453 27.5H41.3584L41.4192 27.6521C41.8611 28.7568 42.0512 29.9464 41.9754 31.1339C41.964 31.3132 41.9467 31.4908 41.9238 31.6667H44.3454C44.651 31.6667 44.8987 31.4189 44.8987 31.1134V28.0533C44.8986 27.7478 44.6509 27.5 44.3453 27.5Z'
        fill='#99E6FC'
      />
      <path
        d='M39.3833 15H34.7933C33.4471 15 32.3556 16.0914 32.3556 17.4377V17.4467C32.3556 17.6496 32.241 17.8351 32.0596 17.9258L30.6478 18.6316C29.6698 19.1206 29.0795 20.1476 29.1491 21.2388L29.7819 31.1564L32.3556 24.7222V23.7967C32.3556 22.7737 33.1849 21.9444 34.2079 21.9444H38.3846C38.9457 21.9444 39.4586 22.2614 39.7096 22.7633L39.8285 23.0012C40.3593 24.0627 41.4474 24.7027 42.6342 24.7224C43.1413 24.7308 43.5949 25.0426 43.7838 25.5147L46.1148 31.3423L46.6625 22.7584C46.9306 18.5559 43.5944 15 39.3833 15Z'
        fill='#0681AF'
      />
      <path
        d='M24.6319 53.8889H19.2226C19.1493 53.8889 19.0965 53.959 19.1166 54.0294L19.8473 56.5869C19.8608 56.6341 19.904 56.6667 19.9532 56.6667H25.4257L24.6319 53.8889Z'
        fill='#B4D2E2'
      />
      <path
        d='M37.4322 34.2374H37.2397C36.8353 34.2374 36.5073 33.9096 36.5073 33.505C36.5073 33.1004 36.8353 32.7726 37.2397 32.7726H37.4322C37.7106 32.7726 37.937 32.5462 37.937 32.2678V30.6455C37.937 30.2409 38.2649 29.9131 38.6694 29.9131C39.0739 29.9131 39.4019 30.2409 39.4019 30.6455V32.2678C39.4019 33.3538 38.5183 34.2374 37.4322 34.2374Z'
        fill='#FFB09E'
      />
      <path
        d='M37.9546 37.9547C36.646 37.9547 35.4157 37.4451 34.4904 36.5198C34.2044 36.2337 34.2044 35.77 34.4904 35.484C34.7764 35.1981 35.2402 35.1981 35.5261 35.484C36.1749 36.1327 37.0373 36.49 37.9546 36.49C38.8719 36.49 39.7344 36.1327 40.383 35.4841C40.669 35.198 41.1328 35.1981 41.4187 35.484C41.7048 35.77 41.7048 36.2338 41.4187 36.5198C40.4934 37.4451 39.2632 37.9547 37.9546 37.9547Z'
        fill='#FFB09E'
      />
      <path
        d='M41.4188 35.484C41.1327 35.1981 40.6689 35.198 40.383 35.4841C40.3545 35.5126 40.3255 35.5406 40.2962 35.5679C39.5187 36.5669 38.5122 37.376 37.3579 37.919C37.5544 37.9427 37.7535 37.9547 37.9546 37.9547C39.2632 37.9547 40.4935 37.4451 41.4188 36.5198C41.7048 36.2337 41.7048 35.7699 41.4188 35.484Z'
        fill='#F89580'
      />
      <path
        d='M53.9536 47.5555H53.7803C53.3758 47.5555 53.0479 47.2277 53.0479 46.8231C53.0479 46.4185 53.3758 46.0907 53.7803 46.0907H53.9536C54.1641 46.0907 54.3353 45.9195 54.3353 45.709V44.2483C54.3353 43.8437 54.6632 43.5159 55.0677 43.5159C55.4722 43.5159 55.8001 43.8437 55.8001 44.2483V45.709C55.8001 46.7272 54.9718 47.5555 53.9536 47.5555Z'
        fill='#FFE5C2'
      />
      <path
        d='M54.4236 50.4061C53.308 50.4061 52.1923 49.9813 51.3429 49.1321C51.0569 48.846 51.0569 48.3823 51.3429 48.0963C51.629 47.8104 52.0927 47.8104 52.3787 48.0963C53.5061 49.2239 55.3408 49.2239 56.4683 48.0963C56.7544 47.8104 57.2181 47.8104 57.5041 48.0963C57.7901 48.3824 57.7901 48.8461 57.5041 49.1321C56.6549 49.9814 55.5392 50.4061 54.4236 50.4061Z'
        fill='#FFE5C2'
      />
      <path
        d='M52.7139 50.0586C53.2585 50.2901 53.841 50.4061 54.4236 50.4061C55.5393 50.4061 56.6549 49.9813 57.5042 49.1321C57.7902 48.846 57.7902 48.3823 57.5042 48.0963C57.2182 47.8104 56.7544 47.8104 56.4685 48.0963C55.9847 48.5801 55.3707 48.8562 54.7384 48.925C54.1373 49.4098 53.4541 49.7955 52.7139 50.0586Z'
        fill='#FED2A4'
      />
      <path
        d='M62.1006 64.9999V62.2222C62.1006 61.8176 61.7727 61.4897 61.3682 61.4897C60.9637 61.4897 60.6357 61.8176 60.6357 62.2222V64.9999H62.1006Z'
        fill='#FAC600'
      />
      <path
        d='M48.2119 64.9999V62.2222C48.2119 61.8176 47.884 61.4897 47.4795 61.4897C47.075 61.4897 46.7471 61.8176 46.7471 62.2222V64.9999H48.2119Z'
        fill='#FAC600'
      />
      <path d='M46.7471 62.9878H48.2119V64.9999H46.7471V62.9878Z' fill='#E8B800' />
      <path
        d='M61.3682 61.4897C60.9637 61.4897 60.6357 61.8176 60.6357 62.2222V64.9999H62.1006V62.2222C62.1006 61.8176 61.7727 61.4897 61.3682 61.4897Z'
        fill='#E8B800'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_7128'>
        <rect width='50' height='50' fill='white' transform='translate(15.7144 15)' />
      </clipPath>
    </defs>
  </svg>
));
PediatricsIcon.displayName = 'PediatricsIcon';

export default PediatricsIcon;
